import ConfirmationModal from 'components/admin/Helper/ConfirmationModal'
import config from 'config/config'
import logo from 'images/logo.svg'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar, loadBadges } from 'redux/navigation'
import { loadCurrentUser } from 'redux/user'
import Routes from 'Routes'
import { Image, Segment } from 'semantic-ui-react'
import MenuAdmin from './MenuAdmin'
import SidebarAdmin from './SidebarAdmin'

const mapStateToProps = (state, ownProps) => {
  const { currentUser } = state.user
  return { currentUser }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      hideSidebar,
      loadBadges,
      loadCurrentUser,
      push,
    },
    dispatch
  )
}

class AdminNavigation extends React.Component {
  componentWillReceiveProps(newProps) {
    const { loadBadges } = this.props
    if (newProps.currentUser && newProps.currentUser.user_type === 'admin')
      loadBadges()
    else newProps.push(config.nodes.login)
  }

  render() {
    const { match } = this.props
    const { currentUser } = this.props
    if (!currentUser || currentUser.user_type !== 'admin') return false
    const dark = config.theme.dark
    return (
      <div className={classNames(['admin', dark && 'inverted'])}>
        <Segment basic className="print">
          <Image src={logo} floated="right" size="small" />
        </Segment>
        <ConfirmationModal />
        <SidebarAdmin>
          <Routes path={match.path} />
        </SidebarAdmin>
        <MenuAdmin />
      </div>
    )
  }
}

AdminNavigation = connect(mapStateToProps, mapDispatchToProps)(AdminNavigation)
export default withRouter(AdminNavigation)



// WEBPACK FOOTER //
// ./src/components/admin/Navigation/AdminNavigation.jsx